import { useMyPurchaseInvoicesToReview } from "api/trading-documents/hooks";
import { MyImportInvoicesTab } from "api/trading-documents/models";
import { InvoicePagination } from "components/common/invoicePagination/InvoicePagination";
import { CommonError, RightPanelHandler } from "components/utils";
import { ListDrawerWrapper } from "components/utils/drawer";
import { ModuleList } from "components/utils/moduleList";
import { RouteComponentProps } from "react-router";
import { ListHeader } from "./components/ListHeader";
import { ModuleListHeader } from "components/utils/moduleList/components/ModuleListHeader";
import { myPurchaseInvoicesToReviewListConfig } from "components/utils/moduleList/utils/moduleListConfig";
import { ModuleListBody } from "components/utils/moduleList/components/ModuleListBody";
import { ListItem } from "./components/ListItem";
import { useQuery } from "hooks";
import { getSearch } from "./utils/getSearch";
import { RightPanel } from "./rightPanel/RightPanel";
import { NoResults } from "components/utils/noResults";
import { Loader } from "components/utils/loader";
import { useState } from "react";
import { HighlightedRow } from "api/other/models";
import { UUID } from "api/types";
import { handleMultipleRowsHighlight } from "utilities/handleMultipleRowsHighlight";
import { ActionToolbar } from "pages/tradingDocuments/shared/components/actionToolbar/ActionToolbar";

export const MyImportPurchaseInvoicesList = ({
  match,
}: RouteComponentProps<{ tab: MyImportInvoicesTab }>) => {
  const { tab } = match.params;
  const { query } = useQuery({ exclude: ["panelId"] });
  const search = getSearch({ query, tab });
  const {
    data: myInvoices,
    error,
    isFetching,
    isLoading,
    pagination,
  } = useMyPurchaseInvoicesToReview(search);

  const [highlightedRows, setHighlightedRows] = useState<HighlightedRow[]>([]);

  const noResults = !myInvoices.length && !isLoading && !error;

  if (error) {
    return (
      <div>
        <ListHeader />
        <div className="mt-4">
          <CommonError status={error._httpStatus_} />
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div>
        <Loader module="finances" />
        <ListHeader />
      </div>
    );
  }

  const selectMutlipleItems = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    id: UUID,
    index: number,
    togglePanel: () => void,
  ) => {
    handleMultipleRowsHighlight(
      event,
      highlightedRows,
      id,
      index,
      setHighlightedRows,
      togglePanel,
      myInvoices,
    );
  };

  return (
    <div className="pageContainer">
      {isFetching && <Loader module="finances" />}
      <ListHeader />
      <RightPanelHandler name="myInvoices">
        {({ close, isActive, isHighlighted, togglePanel }) => (
          <ListDrawerWrapper>
            {noResults ? (
              <NoResults on={noResults} subHeader="faktury zakupowe do zatwierdzenia" />
            ) : (
              <ModuleList>
                <ModuleListHeader
                  gridStyle={myPurchaseInvoicesToReviewListConfig.grid}
                  labels={myPurchaseInvoicesToReviewListConfig.labels}
                />
                <ModuleListBody>
                  {myInvoices.map((myInvoice, index) => (
                    <ListItem
                      highlightedRows={highlightedRows}
                      index={index}
                      isActive={isActive}
                      isHighlighted={isHighlighted}
                      key={myInvoice.id}
                      myInvoice={myInvoice}
                      selectMutlipleItems={selectMutlipleItems}
                      togglePanel={togglePanel}
                    />
                  ))}
                </ModuleListBody>
              </ModuleList>
            )}
            <RightPanel close={close} />
            <InvoicePagination pagination={pagination} />
            {highlightedRows.length > 0 && (
              <ActionToolbar
                actualPage={query.page}
                close={() => {
                  setHighlightedRows([]);
                }}
                quantity={highlightedRows.length}
                highlightedRows={highlightedRows}
                setHighlightedRows={setHighlightedRows}
              />
            )}
          </ListDrawerWrapper>
        )}
      </RightPanelHandler>
    </div>
  );
};
